module.exports = __webpack_public_path__ + "static/media/077.e1ecdd19.jpg";